// extracted by mini-css-extract-plugin
module.exports = {"logos":"SponsorLogos_logos__27oD8","image":"SponsorLogos_image__QBrmx"};